(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewPreliminaryQuestionsController', Controller);

    Controller.$inject = ['$scope', '$rootScope', '$state', 'assessmentQuestions', 'risksToReview', 'assessorId', 'commonRiskSelfAssessmentService'];

    function Controller($scope, $rootScope, $state, assessmentQuestions, risksToReview, assessorId, riskAssessmentService) {
        $scope.assessmentQuestions = assessmentQuestions;
        $scope.ctrlCtxt = {
            isPageValid: false,
            isValidOnPageLoad: false,
            hasChanged: false,
            isSaving: false
        };
        $scope.originalQuestions = null;

        init();

        $scope.hasAssessmentBeenModified = function () {
            return $scope.ctrlCtxt.hasChanged;
        };

        $scope.answerUpdated = function () {
            // TODO When implementing reviewer edit of questions
            //$rootScope.$broadcast('page-is-dirty');
            //$scope.ctrlCtxt.hasChanged = true;
            //checkIfPageIsValid();
        };

        $scope.goToSummary = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.summary', {}, { reload: true });
        };

        $scope.goToAssessors = function () {
            $state.go('riskSelfAssessmentList');
        };

        $scope.shouldHideRatingsLegend = function () {
            return true;
        };

        $scope.isPreviousBtnDisabled = function () {
            return true;
        };

        $scope.isNextBtnDisabled = function () {
            // TODO When implementing reviewer edit of questions
            return false;
            //return !$scope.ctrlCtxt.isValidOnPageLoad;
        };

        $scope.goToNextPage = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.risk', { RiskID: risksToReview[0].Risk.RiskID });
        };

        $scope.isReviewAndContinueActionDisabled = function () {
            // TODO When implementing reviewer edit of questions
            return true;
            //return $scope.ctrlCtxt.isSaving || !$scope.ctrlCtxt.isPageValid;
        };

        // Go to next risk to review
        $scope.goToNextRiskToReview = function () {
            var risk = _.find(risksToReview, function (risk) {
                return !risk.Assessment || !risk.Assessment.HasFinalAssessorReviewed;
            });

            if (!_.isUndefined(risk)) {
                $state.go('riskSelfAssessmentReviewByAssessor.risk', { RiskID: risk.Risk.RiskID });
            } else {
                $state.go('riskSelfAssessmentReviewByAssessor.summary');
            }
        };

        $scope.reviewAndContinue = function () {
            // TODO When implementing reviewer edit of questions
            $scope.goToNextPage();

            //if ($scope.ctrlCtxt.isSaving) return;
            //$scope.ctrlCtxt.isSaving = true;
            //
            //if (!$scope.ctrlCtxt.hasChanged) {
            //    $scope.goToNextPage();
            //    return;
            //}
            //
            //cleanupAnswers($scope.assessmentQuestions.RiskAssessmentQuestions[0]);
            //cleanupAnswers($scope.assessmentQuestions.RiskAssessmentQuestions[1]);

            //riskAssessmentService
            //    .updateAssessmentQuestions($scope.assessmentQuestions, assessorId)
            //    .then(function () {
            //        $scope.goToNextPage();
            //    })
            //    .finally(function () {
            //        $scope.ctrlCtxt.isSaving = false;
            //    });
        };

        function checkIfPageIsValid() {
            // TODO When implementing reviewer edit of questions
            //var isValid;
            //
            //// Question 1
            //var question = $scope.assessmentQuestions.RiskAssessmentQuestions[0];
            //isValid = validateQuestion(question);
            //
            //if (isValid) {
            //    // Question 2
            //    question = $scope.assessmentQuestions.RiskAssessmentQuestions[1];
            //    isValid = validateQuestion(question);
            //}
            //
            //$scope.ctrlCtxt.isPageValid = isValid;
        }

        function validateQuestion(question) {
            // TODO When implementing reviewer edit of questions
            //var isValid = true;
            //for(var i=0; i<question.MinMandatoryAnswer; i++) {
            //    var answer = question.RiskAssessmentAnswers[i];
            //    if (answer._isMandatory && !answer.AssessorValue) {
            //        isValid = false;
            //    }
            //}
            //return isValid;
        }

        function cleanupAnswers(question) {
            // TODO When implementing reviewer edit of questions
            //// Remove empty answers and reassign Depth
            //_.remove(question.RiskAssessmentAnswers, function (answer) {
            //    return !answer.AssessorValue;
            //});
            //_.each(question.RiskAssessmentAnswers, function (answer, index) {
            //    answer.Depth = index+1;
            //});
        }

        function init() {
            // TODO When implementing reviewer edit of questions
            //_.each($scope.assessmentQuestions.RiskAssessmentQuestions, function (question) {
            //    question.RiskAssessmentAnswers = question.RiskAssessmentAnswers || [];
            //    for (var i=0; i<question.MaxAnswer; i++) {
            //        if (!question.RiskAssessmentAnswers[i]) {
            //            question.RiskAssessmentAnswers.push(
            //                riskAssessmentService.createRiskAssessmentAnswer(question.RiskAssessmentQuestionID, question)
            //            );
            //        }
            //        question.RiskAssessmentAnswers[i]._isMandatory = i < question.MinMandatoryAnswer;
            //    }
            //});
            //$scope.originalQuestions = _.cloneDeep($scope.assessmentQuestions);
            //checkIfPageIsValid();
            //$scope.ctrlCtxt.isValidOnPageLoad = $scope.ctrlCtxt.isPageValid;
        }
    }
})();
